import qs from 'query-string';

// hard coded "config values" (more like app constants) here that can't be overridden
let config = {
  // ID of div to mount React SPA in
  APP_MOUNT_ID: 'app',

  // where to write and read config object on window
  APP_CONFIG_PROPERTY: '__CONFIG__',

  // where to write and read redux state object on window
  APP_STATE_PROPERTY: '__STATE__',
};

const { APP_CONFIG_PROPERTY } = config;

// load config from proces.env or window depending on runtime (server or browser)
if (typeof window === 'undefined') {
  config = { ...process.env, ...config, IS_SERVER: true };
} else {
  const queryParamOverrides = qs.parse(window.location.search.slice(1));
  config = { ...window[APP_CONFIG_PROPERTY], ...queryParamOverrides, ...config, IS_SERVER: false };
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js